// @flow
'use strict';

import React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

import { useEffectOnce } from 'lib/viewUtils';
import { Input } from '../../../common/input';

type ModalProps = {
  handleSubmit : () => void,
  url : string,
  open : bool,
  alteraUrl : (tipo : string, query : any) => void,
  fechaModal : () => void,
  listaOpcoes : { label : string, value : string }[]
}

export default function ModalClassificacaoFiscal({ handleSubmit, fechaModal, alteraUrl, url, open, listaOpcoes } : ModalProps) {
  const sendForm = React.useCallback(() => {
    handleSubmit();
    fechaModal();
  }, [handleSubmit, fechaModal]);

  useEffectOnce(() => {
    alteraUrl(url);
  });

  return (
      <Modal show={ open } onHide={ fechaModal } dialogClassName="custom-modal">
        <Form onSubmit={ sendForm }>
          <Modal.Header closeButton>
            <Modal.Title>Classificação Fiscal</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Funcionalidade de uso interno, para registrar o uso das mercadorias compradas.</p>
            <p>Informe o tipo de movimentação fiscal da NFe.</p>
            <Row>
              <Col>
                <Input name="opcaoClassificacao" required label="Classificação geral" options={ listaOpcoes }/>
                <Input name="observacoesClassificacao" label="Observações"/>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="default" onClick={ fechaModal }>Cancelar</Button>
            <Button type="submit" bsStyle="primary">Salvar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
  );
}